import { parseDataVersionParam } from '@hakimo-ui/hakimo/util';
import { DataVersion } from '@hakimo-ui/hakimo/types';
import { useSharedLocationAlarm } from '@hakimo-ui/hakimo/data-access';
import { NotFound, QueryResult } from '@hakimo-ui/hakimo/ui-elements';
import { Alert } from '@hakimo-ui/shared/ui-base';
import { useSearchParams } from 'react-router-dom';
import { AlarmOverviewNoAuth } from './alarm-overview/AlarmOverview';

interface Props {
  sharedToken: string;
  partitionKey?: string;
  dataVersion?: DataVersion;
}

function SharedLocationAlarmDetails(props: Props) {
  const { sharedToken, partitionKey, dataVersion } = props;

  const queryResult = useSharedLocationAlarm(
    sharedToken,
    partitionKey,
    dataVersion
  );

  return (
    <QueryResult
      queryResult={queryResult}
      errorFormatter={() => (
        <div className="mx-auto max-w-screen-2xl p-6">
          <Alert type="error">
            This link is expired or invalid. Please ask the sender for a new
            link.
          </Alert>
        </div>
      )}
    >
      {(data) => (
        <div className="container mx-auto">
          <AlarmOverviewNoAuth
            alarm={data}
            sharedToken={sharedToken}
            dataVersion={dataVersion}
          />
        </div>
      )}
    </QueryResult>
  );
}

export function SharedLocationAlarmRoot() {
  const [searchParams] = useSearchParams();
  const sharedToken = searchParams.get('sharedToken');
  const partitionKey = searchParams.get('partitionKey') ?? undefined;
  // The share link carries its own ?version=v3. This page is reachable by
  // external viewers and has no v2/v3 toggle of its own, so the data version
  // must come from the URL only — never from dataVersionOverrideAtom, which is
  // the Location Alarms page's localStorage state and unrelated to this alarm.
  const dataVersion = parseDataVersionParam(searchParams);

  if (sharedToken === null) {
    return (
      <NotFound message="Missing shared token in shared location alarm URL" />
    );
  }

  return (
    <SharedLocationAlarmDetails
      sharedToken={sharedToken}
      partitionKey={partitionKey}
      dataVersion={dataVersion}
    />
  );
}

export default SharedLocationAlarmRoot;
